<template>
  <div class="schedule" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <div class="header" :style="{backgroundColor:isInScheduleBox?'#ff3c00':'#fff'}">
      <div style="margin-top: 2vh">
        <img src="https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg" style="width: 12vh"
             v-if="isInScheduleBox">
        <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg" style="width: 12vh" v-else>
      </div>
      <div>
        <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E7%99%BD.svg"
             style="width: 10vh" v-if="isInScheduleBox">
        <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B.svg"
             style="width: 10vh" v-else>
      </div>
      <div style="margin-bottom: 2vh">
        <img
          src="https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87-%E7%99%BD.svg"
          style="width: 9.5vh;" v-if="isInScheduleBox">
        <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87.svg"
             style="width: 9.5vh;" v-else>
      </div>
    </div>
    <div class="content">
      <div class="day-1">
        <div class="left">
          <img src="https://summit-img.geekpark.net/ifx/pc/v4-12.20-%E5%91%A8%E4%BA%94.svg"
               style="width: 42vh;align-self: flex-end;"
               :style="{transform:`translate3d(${topImagePosition}px,0,0)`}">
          <p style="width: 65%;margin-left:8%;line-height:1.5;text-align: justify;font-size: 2.3vh;font-weight: 100">
            12 月 20 日，极客公园创始人兼总裁张鹏，将联合得到 App
            总编辑李翔，奉献一场关于商业常识与真相的思维共振。围绕微信、小米、支付宝、美团、拼多多、字节跳动、滴滴这些大众熟知的企业，让我们回顾上一个十年的互联网往事，预演下一个十年的商业算法。
          </p>
        </div>
        <div class="right panel-content">
          <img src="https://summit-img.geekpark.net/ifx/pc/IFX-v3-%E7%BD%91%E7%AB%99%E5%88%87%E5%9B%BE-pc.png" alt=""
               style="height: 90vh;margin-left: 7vh;">
          <a class="replay-btn-link1 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=283DC1D9E60097BB9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
            <!-- //回放按钮 -->
          </a>
          <a class="replay-btn-link2 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=F08273812EB9BF3A9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
          </a>
          <a class="replay-btn-link3 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=F75E1B33B5C484BA9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
          </a>
          <a class="replay-btn-link4 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=EE955560E367A6979C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
          </a>
          <a class="replay-btn-link5 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=7AA1BBDF700142889C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
          </a>
          <a class="replay-btn-link6 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=89A59F3C8095B3749C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
          </a>
          <a class="replay-btn-link7 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=D8C9706E80BF599F9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
          </a>
        </div>
        <div class="line"></div>
      </div>
      <div class="day-2">
        <div class="extra">
          <div class="think">
            <img src="https://summit-img.geekpark.net/ifx/pc/thinking.svg" style="width: 90vh">
            <div style="width: 90vh;margin-top: -10vh;text-align: right;">
              <img
                src="https://summit-img.geekpark.net/ifx/pc/%E6%97%A5%E7%A8%8B%E6%8C%81%E7%BB%AD%E6%9B%B4%E6%96%B0-pc.svg"
                style="width: 18vh">
            </div>
            <p style="text-align: left;font-size: 2.2vh">
              在「未来趋势论坛」和「极致成长论坛」中，<br>
              你将听到科技先锋力量们对以下六个问题的探讨和思考：
            </p>
            <img src="https://summit-img.geekpark.net/ifx/pc/questions.svg" style="width: 100vh;">
          </div>
        </div>
        <div class="left">
          <img src="https://summit-img.geekpark.net/ifx/pc/v3-12.21-%E5%91%A8%E5%85%AD.svg"
               style="width: 42vh;align-self: flex-end;"
               :style="{transform:`translate3d(${middleImagePosition}px,0,0)`}">
          <p style="width: 65%;margin-left:8%;line-height:1.5;text-align: justify;font-size: 2.6vh;font-weight: 100">
            世界前行的方向总是由少数派掌控，他们屏蔽喧嚣、独立思考，用虔诚的科技信仰与独树一帜的判断力引领产业形成共同的价值认同。什么是未来？崛起的先锋力量，他们便是答案。
          </p>
        </div>
        <div class="right">
          <div class="item" v-for="(item,index) in schedule21" :key="index">
            <div class="item-content">
              <div class="head">
                <span class="time">{{item.start_at | parseTime}}</span>
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E5%B0%8F%E4%BC%97%E4%B8%8E%E5%A4%A7%E4%BC%97.svg"
                  style="height: 2.2vh;" v-if="item.description === '小众与大众'">
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E7%AA%81%E7%A0%B4%E4%B8%8E%E4%BC%A0%E6%89%BF.svg"
                  style="height: 2.2vh;" v-if="item.description === '突破与传承'">
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E8%99%9A%E6%8B%9F%E4%B8%8E%E7%8E%B0%E5%AE%9E.svg"
                  style="height: 2.2vh;" v-if="item.description === '虚拟与现实'">
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E7%A7%91%E6%8A%80%E4%B8%8E%E4%BA%BA%E6%80%A7.svg"
                  style="height: 2.2vh;" v-if="item.description === '科技与人性'">
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E4%B8%8E%E4%BA%BA.svg"
                  style="height: 2.2vh;" v-if="item.description === '人工智能与人'">
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E4%BC%A0%E7%BB%9F%E4%B8%8E%E5%88%9B%E6%96%B0.svg"
                  style="height: 2.2vh;" v-if="item.description === '传统与创新'">
              </div>
              <h2>{{item.title}}</h2>
              <div v-if="item.image" style="position: absolute; bottom: 2vh;text-align: left">
                <img :src="item.image" style="width: 70%;vertical-align: bottom;">
              </div>
              <div class="guest" v-else>
                <img
                  :src="item.guests[0].avator.url"
                  alt="">
                <div class="guest-info">
                  <div class="replay-btn-wrapper">
                    <h2>{{item.guests[0].company}}</h2>
                    <a class="replay-btn-link" :data-href="item.live_url||'https://if.geekpark.net/'">
                      <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
                    </a>
                  </div>
                  <p>{{item.guests[0].name}}</p>
                  <p>{{item.guests[0].title}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="day-3">
        <div class="left">
          <img src="https://summit-img.geekpark.net/ifx/pc/v3-12.22-%E5%91%A8%E6%97%A5.svg"
               style="width: 42vh;align-self: flex-end;"
               :style="{transform:`translate3d(${bottomImagePosition}px,0,0)`}">
          <p style="width: 65%;margin-left:8%;line-height:1.5;text-align: justify;font-size: 2.3vh;font-weight: 100">
            成长是商业组织的永恒话题，如何寻找创新原点，如何看清商业的规律，如何突破瓶颈持续向上，是每一个「企业家」的必修课。
          </p>
        </div>
        <div class="right">
          <div class="item" v-for="(item,index) in schedule22" :key="index">
            <div class="item-content">
              <div class="head">
                <span class="time">{{item.start_at | parseTime}}</span>
                <img src="https://summit-img.geekpark.net/ifx/images/%E5%B0%8F%E4%BC%97%E4%B8%8E%E5%A4%A7%E4%BC%97.svg"
                     style="height: 2.2vh;" v-if="item.description === '小众与大众'">
                <img src="https://summit-img.geekpark.net/ifx/images/%E7%AA%81%E7%A0%B4%E4%B8%8E%E4%BC%A0%E6%89%BF.svg"
                     style="height: 2.2vh;" v-if="item.description === '突破与传承'">
                <img src="https://summit-img.geekpark.net/ifx/images/%E8%99%9A%E6%8B%9F%E4%B8%8E%E7%8E%B0%E5%AE%9E.svg"
                     style="height: 2.2vh;" v-if="item.description === '虚拟与现实'">
                <img src="https://summit-img.geekpark.net/ifx/images/%E7%A7%91%E6%8A%80%E4%B8%8E%E4%BA%BA%E6%80%A7.svg"
                     style="height: 2.2vh;" v-if="item.description === '科技与人性'">
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E4%B8%8E%E4%BA%BA.svg"
                  style="height: 2.2vh;" v-if="item.description === '人工智能与人'">
                <img src="https://summit-img.geekpark.net/ifx/images/%E4%BC%A0%E7%BB%9F%E4%B8%8E%E5%88%9B%E6%96%B0.svg"
                     style="height: 2.2vh;" v-if="item.description === '传统与创新'">
              </div>
              <h2>{{item.title}}</h2>
              <div v-if="item.image" style="position: absolute; bottom: 2vh;text-align: left">
                <img :src="item.image" style="width: 70%;vertical-align: bottom;">
              </div>
              <div v-if="!item.image && item.guests.length > 1" style="text-align: right;">
                <a class="replay-btn-link" :data-href="item.live_url||'https://if.geekpark.net/'">
                  <img class="replay-btn" style="height:2.6vh;width:auto" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
                </a>
              </div>
              <template v-if="!item.image && item.guests.length > 1">
                <div :class="`guest${key}`" v-for="(value,key) in item.guests" :key="key">
                  <img
                    :src="item.guests[key].avator.url"
                    alt="">
                  <div class="guest-info">
                    <h2>{{value.name}}</h2>
                    <p>{{value.company}}</p>
                    <p>{{value.title}}</p>
                  </div>
                </div>
              </template>
              <template v-if="!item.image && item.guests.length === 1">
                <div class="guest" v-for="(value,key) in item.guests" :key="key">
                  <img
                    :src="item.guests[0].avator.url"
                    alt="">
                  <div class="guest-info">
                    <div class="replay-btn-wrapper">
                      <h2>{{value.name}}</h2>
                      <a class="replay-btn-link" :data-href="item.live_url||'https://if.geekpark.net/'">
                        <!-- <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/> -->
                      </a>
                    </div>
                    <p>{{value.company}}</p>
                    <p>{{value.title}}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import moment from 'moment'

export default {
  name: 'Schedule',
  data () {
    return {
      schedule21: [],
      schedule22: [],
      isInScheduleBox: false,
      scrollHeight: 0,
      topImagePosition: 0,
      middleImagePosition: 0,
      bottomImagePosition: 0
    }
  },
  created () {
    axios.get('https://events.geekpark.net/api/v1/activities/f17e2e76-b88b-42e9-a311-48897ae5ba8a').then(res => {
      this.$emit('updatePartners', res.data.activity.partner_categories)
      const schedule21 = res.data['vice_activities'][0].speeches[0].speeches.sort((prev, next) => {
        return moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
      })
      this.schedule21 = Object.assign([], schedule21)
      const schedule22 = res.data['vice_activities'][1].speeches[0].speeches.sort((prev, next) => {
        return moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
      })
      this.schedule22 = Object.assign([], schedule22)
      this.bindHover()
      this.replayBtnHover()
      this.handleClickReplay()
    })
    window.addEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    bindHover () {
      $('.right').on('mouseenter', '.guest0', function (e) {
        $(this).parent().children('.guest1,.guest2,.guest3').hide()
        $(this).addClass('guest-hover')
      }).on('mouseenter', '.guest1', function (e) {
        $(this).parent().children('.guest0,.guest2,.guest3').hide()
        $(this).addClass('guest-hover')
      }).on('mouseenter', '.guest2', function (e) {
        $(this).parent().children('.guest0,.guest1,.guest3').hide()
        $(this).addClass('guest-hover')
      }).on('mouseenter', '.guest3', function (e) {
        $(this).parent().children('.guest0,.guest1,.guest2').hide()
        $(this).addClass('guest-hover')
      }).on('mouseleave', '.guest0', function (e) {
        $(this).parent().children('.guest0,.guest1,.guest2,.guest3').show()
        $(this).removeClass('guest-hover')
      }).on('mouseleave', '.guest1', function (e) {
        $(this).parent().children('.guest0,.guest1,.guest2,.guest3').show()
        $(this).removeClass('guest-hover')
      }).on('mouseleave', '.guest2', function (e) {
        $(this).parent().children('.guest0,.guest1,.guest2,.guest3').show()
        $(this).removeClass('guest-hover')
      }).on('mouseleave', '.guest3', function (e) {
        $(this).parent().children('.guest0,.guest1,.guest2,.guest3').show()
        $(this).removeClass('guest-hover')
      })
    },
    replayBtnHover () {
      $('.right').on('mouseenter', '.replay-btn', function (e) {
        e.target.src = 'https://summit-img.geekpark.net/ifx/images/replay_btn_hover.svg'
      }).on('mouseleave', '.replay-btn', function (e) {
        e.target.src = 'https://summit-img.geekpark.net/ifx/images/replay_btn.svg'
      })
    },
    handleClickReplay () {
      $('.right').on('click', '.replay-btn-link', function (e) {
        const viframe = $('#ifx_video_iframe')
        const is = viframe.attr('src')
        if (is === e.currentTarget.dataset.href) return
        $('#ifx_video_iframe_wrapper').css('display', 'block')
        viframe.attr('src', e.currentTarget.dataset.href)
      })
    },
    mouseEnter () {
      this.isInScheduleBox = true
    },
    mouseLeave () {
      this.isInScheduleBox = false
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollInstance = scrollHeight - this.scrollHeight
      this.scrollHeight = scrollHeight
      for (let i = 1; i < 4; i++) {
        const { left, width } = document.querySelector(`.day-${i}`).getBoundingClientRect()
        if (left <= document.body.offsetWidth && left >= -width) {
          if ((scrollInstance > 0 && this.topImagePosition >= -width) || (scrollInstance < 0 && this.topImagePosition <= 0)) {
            const distance = scrollInstance / 40
            switch (i) {
              case 1:
                this.topImagePosition -= distance
                break
              case 2:
                this.middleImagePosition -= distance
                break
              case 3:
                this.bottomImagePosition -= distance
                break
              default:
                break
            }
          }
        }
      }
    }
  },
  filters: {
    parseTime: function (date) {
      return moment(date).format('HH:mm')
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .schedule {
    display: flex;
    height: 100%;
    margin-left: 13vh;
  }

  .header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 18vh;
    margin: 5vh 0;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    transition: background-color .3s;
  }

  .content {
    display: flex;

    > div {
      height: 100%;
      box-sizing: border-box;

      img {
        transition: transform .5s ease-out;
      }
    }
    .panel-content{
      position: relative;
      .replay-btn{
        width: 8vh;
        height: auto;
        &:hover{
          cursor: pointer;
        }
      }
      .replay-btn-link1{
        position: absolute;
        top: 26vh;
        right: 110vh;
      }
      .replay-btn-link2{
        position: absolute;
        top: 26vh;
        right: 70vh;
      }
      .replay-btn-link3{
        position: absolute;
        top: 26vh;
        right: 30vh;
      }
      .replay-btn-link4{
        position: absolute;
        top: 71vh;
        right: 150vh;
      }
      .replay-btn-link5{
        position: absolute;
        top: 71vh;
        right: 110vh;
      }
      .replay-btn-link6{
        position: absolute;
        top: 71vh;
        right: 70vh;
      }
      .replay-btn-link7{
        position: absolute;
        top: 71vh;
        right: 30vh;
      }

    }
  }

  .line {
    width: 1px;
    height: 90vh;
    background: #000;
  }

  .left {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    width: 54vh;
    height: 90vh;
    margin-left: 10vh;
    background-color: #f9f9f9;
  }

  .item {
    display: flex;
    box-sizing: border-box;
    width: 44vh;
    height: 22.5vh;
    padding: 1vh 2vh;
    background-clip: content-box;
    background-color: #f9f9f9;

    .item-content {
      width: 100%;
      height: 100%;
      position: relative;
      padding: 1vh 1.8vh 0vh 1.8vh;

      .head {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 2.5vh;
        font-weight: 800;

        .time {
          color: #ff3c00;
          font-family: SyncopateBold;
        }
      }

      > h2 {
        margin-top: .8vh;
        line-height: 1.2;
        text-align: left;
        font-size: 2.2vh;
      }

      .guest {
        display: flex;
        justify-content: flex-start;
        position: absolute;
        bottom: 2vh;
        width: calc(100% - 1.8vh);
        text-align: left;

        img {
          width: 9.2vh;
          height: 9.2vh;
          border-radius: 4.6vh;
        }

        .guest-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: .4vh 2.5vh;
          font-size: 1.8vh;
          flex:1;

          .replay-btn-wrapper{
            display: flex;
            align-items: center;
            justify-content: space-between;

            .replay-btn{
              height: 2.6vh;
              width: auto;
              &:hover{
                cursor: pointer;
              }
            }

          }

          h2 {
            color: #ff3c00;
            font-size: 2.2vh;
          }

          p {
            white-space: nowrap;

            &:last-child {
              color: #535353;
            }
          }
        }
      }

      .guest0, .guest1, .guest2, .guest3 {
        .guest;
        width: 8.4vh;
        height: 8.4vh;

        > .guest-info {
          display: none;
        }

        > img {
          width: 8.4vh;
          height: 8.4vh;
        }
      }

      .guest1 {
        left: 28%;
      }

      .guest2 {
        left: 51%;
      }

      .guest3 {
        left: 75%;
      }

      .guest-hover {
        width: 100%;
        left: 4.5%;
        transition: left .3s linear;

        > .guest-info {
          display: flex;
          visibility: visible;
        }
      }
    }

  }

  .day-1 {
    display: flex;
    align-items: center;

    .right {
      display: flex;
      align-items: center;
      height: 100vh;
      margin-right: 10vh;
    }
  }

  .day-2 {
    padding: 5vh 0;
    display: flex;

    .extra {
      display: flex;
      align-items: center;
      margin-left: 10vh;

      .think {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        height: 80vh;
      }
    }

    .right {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 176vh;
      height: 92vh;
      margin: -1vh 8vh auto 7vh;

      &:after {
        content: "";
        flex: auto;
      }
    }
  }

  .day-3 {
    padding: 5vh 0;
    display: flex;

    > div {
      margin-left: 10vh;
    }

    .right {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 176vh;
      height: 92vh;
      margin: -1vh 8vh auto 7vh;

      &:after {
        content: "";
        flex: auto;
      }
    }
  }
</style>
